// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_id-6";
export var emphasizeQuantity = "_id-3";
export var flatBottomCorners = "_id-5";
export var productImage = "_id-0";
export var quantityContainer = "_id-2";
export var tooltip = "_id-1";
export var wrapAndEllipsesOverflow = "_id-4";